import { useMutation } from '@apollo/client';
import CreateSubscriptionMutation from './CreateSubscriptionMutation';

const CreateSubscriptionConnectorApollo = ({ children }) => {
  const [createSubscription, { data, loading, error }] = useMutation(CreateSubscriptionMutation);

  const createBuy = async (request) => {
    const response = await createSubscription({
      variables: request,
    });

    return response;
  };

  return children({
    buy: createBuy,
    response: data,
    loading,
    error,
  });
};

export default CreateSubscriptionConnectorApollo;
